import { render } from "./ImagePlusOutline.vue?vue&type=template&id=243b8b16"
import script from "./ImagePlusOutline.vue?vue&type=script&lang=js"
export * from "./ImagePlusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__